var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationObserver',{ref:"observer",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
var reset = ref.reset;
var validate = ref.validate;
return [_c('form',{attrs:{"data-cy":_vm.dataCy},on:{"submit":function($event){$event.preventDefault();{
        _vm.handleSumbitRequest(handleSubmit, reset, validate);
      }}}},[_c('v-skeleton-loader',{attrs:{"loading":_vm.loading}},[_vm._t("formBody",null,{"reset":reset})],2)],1)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }